import { isTaskInHistory, resolveTaskStatus } from '../helpers';
import { getTaskPayoutTimestamp } from './taskPayoutDate';
import {
    computeEscrowAmounts,
    isTaskLockedInEscrow,
    isTaskPaidOut,
} from './escrowMetrics';

export function computeEarningsBreakdown(tasks = [], role = 'employee') {
    let totalReleased = 0;
    let pendingRelease = 0;
    let inEscrowActive = 0;
    let releasedCount = 0;
    let pendingCount = 0;
    let activeCount = 0;
    let lockedCount = 0;

    tasks.forEach((task) => {
        const amount = Number(task.amount) || 0;
        const status = resolveTaskStatus(task);

        if (isTaskPaidOut(task)) {
            totalReleased += amount;
            releasedCount += 1;
        } else if (status === 'submitted') {
            pendingRelease += amount;
            pendingCount += 1;
        } else if (['active', 'pending'].includes(status)) {
            inEscrowActive += amount;
            activeCount += 1;
        }

        if (isTaskLockedInEscrow(task)) {
            lockedCount += 1;
        }
    });

    const escrow = computeEscrowAmounts(tasks);
    const inEscrow = role === 'company' ? escrow.locked : inEscrowActive;

    return {
        totalReleased,
        pendingRelease,
        inEscrow,
        inEscrowActive,
        releasedCount,
        pendingCount,
        activeCount,
        lockedCount,
    };
}

export function buildEarningsLedger(tasks = []) {
    return tasks
        .filter((task) => isTaskInHistory(task) || resolveTaskStatus(task) === 'released')
        .map((task) => ({
            id: task.id,
            title: task.title,
            amount: Number(task.amount) || 0,
            status: resolveTaskStatus(task),
            date: getTaskPayoutTimestamp(task) || task.createdAt,
            releaseTxHash: task.payment?.releaseTxHash || null,
            fundTxHash: task.txHash || task.payment?.txHash || null,
        }))
        .sort(
            (a, b) =>
                new Date(b.date || 0).getTime() - new Date(a.date || 0).getTime(),
        );
}

export function buildPendingPayouts(tasks = []) {
    return tasks
        .filter((task) => resolveTaskStatus(task) === 'submitted')
        .map((task) => ({
            id: task.id,
            title: task.title,
            amount: Number(task.amount) || 0,
            date: task.updatedAt || task.createdAt,
        }))
        .sort(
            (a, b) =>
                new Date(b.date || 0).getTime() - new Date(a.date || 0).getTime(),
        );
}
